var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrowthleftarrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.98352 7.6673C0.810329 7.49411 0.741053 7.28628 0.741053 7.04381C0.741053 6.83598 0.810329 6.62815 0.98352 6.45496L7.07984 0.63575C7.42622 0.324007 7.94579 0.324007 8.25753 0.670388C8.56928 0.982132 8.56928 1.53634 8.22289 1.84809L3.61602 6.21249H15.4276C15.8779 6.21249 16.2589 6.59351 16.2589 7.04381C16.2589 7.52874 15.8779 7.87513 15.4276 7.87513H3.61602L8.22289 12.2742C8.56928 12.5859 8.56928 13.1055 8.25753 13.4519C7.94579 13.7983 7.42622 13.7983 7.07984 13.4865L0.98352 7.6673Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowthleftarrow);
export default __webpack_public_path__ + "static/media/growthleftarrow.baed5bb04481c02e9dc07e0f67a44b1f.svg";
export { ForwardRef as ReactComponent };